export const sectionType = {
  sectionCardWithSurvey: 'section-card-with-survey',
  sectionCustomizeCard: 'section-customize-card',
  sectionFreestyle: 'section-freestyle',
  // sectionImageWithText: 'section-image-with-text',
  sectionProductGrid: 'section-product-grid',
  sectionSatelliteGrid: 'section-grid-satellite',
  sectionQuestionFaq: 'section-question-faq',
  sectionIconWithText: 'section-icon-with-text',
  sectionCardDualImg: 'section-card-dual-img',
  sectionFindAnswer: 'section-find-answer',
  sectionTextCarousel: 'section-text-carousel',
  sectionHeading: 'section-heading',
  sectionCardSmoking: 'section-card-smoking',
  sectionReviewGrid: 'section-review-grid',
  sectionReviewGrid02: 'section-review-grid-02',
  sectionProductReviews: 'section-product-reviews',
  sectionProductReviews02: 'section-product-reviews-02',
  sectionProductReviews03: 'section-product-reviews-03',
  sectionProductReviews04: 'section-product-reviews-04',
  sectionProductReviews05: 'section-product-reviews-05',
  sectionReviewGridKindLokal: 'section-review-grid-kind-lokal',
  sectionMarqueeBasicText: 'section-marquee-basic-text',
  sectionTextSurvey: 'section-text-survey',
  sectionCompareTwoImg: 'section-compare-two-img',
  sectionCardCompareYuri: 'section-card-compare-yuri',
  sectionCardTimelineYuri: 'section-card-timeline-yuri',
  sectionCardSliderYuri: 'section-card-slider-yuri',
  sectionCardStatisticsYuri: 'section-card-statistics-yuri',
  sectionReviewSliderYuri: 'section-review-slider-yuri',
  sectionMarqueeYuri: 'section-marquee-yuri',
  sectionCardWithTableCompare: 'section-card-with-table-compare',
  sectionBannerSlider: 'section-banner-slider',
  sectionIconWitTextSlider: 'section-icon-with-text-slider',
  sectionSubscribeEmail: 'section-subcribe-email',
  sectionCardSona: 'section-card-sona',
  sectionTinoGrid: 'section-tino-grid',
  sectionReviewInfiniteMarquee: 'section-review-infinite-marquee',
  sectionFaqGrid: 'section-faq-grid',
  sectionCollapsibleProductGrid: 'section-collapsible-product-grid',
  sectionCardVideoSlider: 'section-card-video-slider',
  sectionCardVideo: 'section-card-video',
  // sectionCardHaveViewMore: 'section-card-have-view-more',
  sectionCardAccordions: 'section-card-accordions',
  sectionMarqueeTino: 'section-marquee-tino',
  sectionMarqueeImage: 'section-marquee-image', // start
  sectionTabs: 'section-tabs',
  sectionCardMediaSlider: 'section-card-media-slider',
  sectionCardMediaSlider02: 'section-card-media-slider-02',
  sectionCardMediaSlider03: 'section-card-media-slider-03',
  sectionCardFeeSizeImg: 'section-card-fee-size-img',
  sectionTableKubo: 'section-table-kubo',
  sectionItemsGrid: 'section-items-grid',
  sectionItemsGrid02: 'section-items-grid-02',
  sectionCardStepInstructions: 'section-card-step-instructions',
  sectionPurchaseIncentive: 'section-purchase-incentive',
  sectionSocialMedia: 'section-social-media',
  sectionFeaturedOffer: 'section-featured-offer',
  sectionPost: 'section-post',
  sectionCardReview: 'section-card-review',
  sectionCardStep: 'section-card-step',
  sectionTableBenefitsComparison: 'section-table-benefits-comparison',
  sectionBannerB1: 'section-banner-b1',
  sectionItemsSlideB1: 'section-items-slide-b1',
  sectionCardBasicB1: 'section-card-basic-b1',
  sectionCardCompareB1: 'section-card-compare-b1',
  sectionBannerBasicB1: 'section-banner-basic-b1',
  sectionTableSmallB1: 'section-table-small-b1',
  sectionIconWithTextB1: 'section-icon-with-text-b1',
  sectionSocialComment: 'section-social-comment',
  sectionFaqGrid02: 'section-faq-grid-02',
  sectionFaqGrid03: 'section-faq-grid-03',
  sectionFaqGrid04: 'section-faq-grid-04',
  sectionFaqGrid05: 'section-faq-grid-05',
  sectionFaqGrid06: 'section-faq-grid-06',
  sectionCardFeature: 'section-card-feature',
  sectionCardReview02: 'section-card-review-02',
  sectionCardMedia: 'section-card-media',
  sectionCardKeyFeatures: 'section-card-key-features',
  sectionImageWithTextBasic: 'section-image-with-text-basic',
  sectionReviewGridSection03: 'section-review-grid-section-03',
  sectionFaqCard: 'section-faq-card',
  sectionBannerMedia: 'section-banner-media',
  sectionCardMultiTool: 'section-card-multi-tool',
  sectionCardMultiToolYuri: 'section-card-multi-tool-yuri',
  sectionCardMultiToolDouble: 'section-card-multi-tool-double',
  sectionMarkqueueRows: 'section-markqueue-rows',
  sectionFbPost03: 'section-fb-post-03',
  sectionTpla: 'section-tpla',
  sectionReviewTitan: 'section-review-titan',
  sectionCardCompareProduct: 'section-card-compare-product',
  sectionItemsGrid03: 'section-items-grid-03',
  sectionItemsGrid04: 'section-items-grid-04',
  sectionReviewGrid04: 'section-review-grid-04',
  sectionReviewGrid05: 'section-review-grid-05',
  sectionItemsGrid05: 'section-items-grid-05',
  sectionItemsGrid06: 'section-items-grid-06',
  sectionCardBasic: 'section-card-basic',
  sectionItemsGridMedia: 'section-items-grid-media',
  sectionCardStepInstructions02: 'section-card-step-instructions-02',
  sectionBannerBasic: 'section-banner-basic',
  sectionBannerFastvaluedeal: 'section-banner-fastvaluedeal',
  sectionCardBannerRivoneed: 'section-card-banner-rivoneed',
  sectionCardBanner02Rivoneed: 'section-card-banner-02-rivoneed',
  sectionCardSatelliteRivoneed: 'section-card-satellite-rivoneed',
  sectionCardWithSliderRivoneed: 'section-card-with-slider-rivoneed',
  sectionCardGridItemRivoneed: 'section-card-grid-item-rivoneed',
  sectionCardSliderRivoneed: 'section-card-slider-rivoneed',
  sectionMarqueeRivoneed: 'section-marquee-rivoneed',
  sectionCardBasicRivoneed: 'section-card-basic-rivoneed',
  sectionCardBadgeRivoneed: 'section-card-badge-rivoneed',
  sectionCardFaqRivoneed: 'section-card-faq-rivoneed',
  sectionCardBannerGatorz: 'section-card-banner-gatorz',
  sectionCardGatorzCustom: 'section-card-gatorz-custom',
  sectionCardGatorzGridItem: 'section-card-gatorz-grid-item',
  sectionCardFastvaluedealTitleImg: 'section-card-fastvaluedeal-title-img',
  sectionSliderFastvaluedeal01: 'section-slider-fastvaluedeal-01',
  sectionFreestyleInfo: 'section-freestyle-info',
  sectionProductReviews06: 'section-product-reviews-06',
  sectionTextWithButton: 'section-text-with-button',
  sectionFaqVital: 'section-faq-vital',
  sectionCardVitalSlider: 'section-card-vital-slider',
  sectionCardVitalSlider02: 'section-card-vital-slider-02',
  sectionCardVitalSurround: 'section-card-vital-surround',
  sectionCardVitalTab: 'section-card-vital-tab',
  sectionReviewVital: 'section-review-vital',
  sectionPolicyAccordionBasic: 'section-policy-accordion-basic',
  sectionMoneyBackGuarantee: 'section-money-back-guarantee',
  sectionPolicyYuriAccordion: 'section-policy-yuri-accordion',
  sectionPolicyYuriList: 'section-policy-yuri-list',
  sectionPolicyYuriVideos: 'section-policy-yuri-videos',
  sectionPolicyYuriReivew: 'section-policy-yuri-reivew',
  sectionFastvaluedealReviews: 'section-fastvaluedeal-reviews',
  sectionFastvaluedealCountdown: 'section-fastvaluedeal-countdown',
  sectionFastvaluedealFaq: 'section-fastvaluedeal-faq',
  sectionFastvaluedealMoneyBackGuarantee: 'section-fastvaluedeal-money-back-guarantee',
  sectionFastvaluedealReviewer: 'section-fastvaluedeal-reviewer',
  sectionFastvaluedealCta: 'section-fastvaluedeal-cta',
  sectionFastvaluedealCardBasic: 'section-fastvaluedeal-card-basic',
  sectionFastvaluedealCardStep: 'section-fastvaluedeal-card-step',
  sectionFastvaluedealCompareBenefits: 'section-fastvaluedeal-compare-benefits',
  sectionFastvaluedealTable: 'section-fastvaluedeal-table',
  sectionMarkqueueOrthopedic: 'section-markqueue-orthopedic',
  sectionOrthopedicFeaturesGrid: 'section-orthopedic-features-grid',
  sectionOrthopedicCardFeatures: 'section-orthopedic-card-features',
  sectionOrthopedicCardReview: 'section-orthopedic-card-review',
  sectionOrthopedicCardBasic: 'section-orthopedic-card-basic',
  sectionLosaprilyReviews: 'section-losaprily-reviews',
  sectionLosaprilyImagesGrid: 'section-losaprily-images-grid',
  sectionCardMediaWithSliderLosaprily: 'section-card-media-with-slider-losaprily',
  sectionCardTabWithContentLosaprily: 'section-card-tab-with-content-losaprily',
  sectionLosaprilyCardBanner: 'section-losaprily-card-banner',
  sectionSowhatbuyCardBasic: 'section-sowhatbuy-card-basic',
  sectionSowhatbuyGuaranteeMarquee: 'section-sowhatbuy-guarantee-marquee',
  sectionSowhatbuyFeaturesSlider: 'section-sowhatbuy-features-slider',
  sectionSowhatbuyReward: 'section-sowhatbuy-reward',
  sectionSowhatbuyCardImage: 'section-sowhatbuy-card-image',
  sectionTryherReviewGrid: 'section-tryher-review-grid',
  sectionTryherGridPercent: 'section-tryher-grid-percent',
  sectionTryherTimeline: 'section-tryher-timeline',
  sectionTryherCardCompare: 'section-tryher-card-compare',
  sectionTryherCardBasic: 'section-tryher-card-basic',

  //hurrybox
  sectionFreestyleHurryBox: 'section-freestyle-hurry-box',
  sectionCoutdownHurryBox: 'section-countdown-hurry-box',
  sectionSizingChartHurryBox: 'section-sizing-chart-hurry-box',
  sectionHarryboxYuri: 'section-hurrybox-yuri',
  //order policy
  sectionGuaranteedSafeCheckout: 'section-guaranteed-safe-checkout',
  sectionGuaranteedSafeCheckout02: 'section-guaranteed-safe-checkout-02',
  sectionOrderInfo: 'section-order-info',
  sectionFreestyleOrderPolicy: 'section-freestyle-order-policy',
  sectionTrustBadge: 'section-trust-badge',
  sectionSaintbrandShipping: 'section-saintbrand-shipping',
  sectionGatorzYoutube: 'section-gatorz-youtube',
  sectionGatorzCompareImage: 'section-gatorz-compare-image',
  sectionGatorzReviews: 'section-gatorz-reviews',
  sectionSaintbrandReviews: 'section-saintbrand-reviews',
  sectionGatorzSupport: 'section-gatorz-support',
  sectionGatorzFrameSpecs: 'section-gatorz-frame-specs',
  sectionGatorzPolicy: 'section-gatorz-policy',
  sectionSaintbrandInfiniteMarquee: 'section-saintbrand-infinite-marquee',
  sectionSaintbrandFeaturesGrid: 'section-saintbrand-features-grid',
  sectionMarqueeShopzovya: 'section-marquee-shopzovya',
  sectionCardBannerSowhatbuy: 'section-card-banner-sowhatbuy',
  sectionCardItemsSowhatbuy: 'section-card-items-sowhatbuy',
  sectionCardCompareSowhatbuy: 'section-card-compare-sowhatbuy',
  sectionImageWithTextCol1: 'section-image-with-text-col-1',
  sectionSideBySideGridIcon: 'section-side-by-side-grid-icon',
  sectionLeonieandcoReviewGrid: 'section-leonieandco-review-grid',
  sectionCedrowFreetypeContent: 'section-cedrow-freetype-content',
  sectionCardCedrowWithTab: 'section-card-cedrow-with-tab',
  sectionCardCedrowSideBySide: 'section-card-cedrow-side-by-side',
  sectionCardCedrowWithTabel: 'section-card-cedrow-with-tabel',
  sectionCardCedrowBenefitsPolicy: 'section-card-cedrow-benefits-policy',
  sectionCardCedrowGridIcons: 'section-card-cedrow-grid-icons',
  sectionUpairyTabs: 'section-upairy-tabs',
  sectionUpairyTimeline: 'section-upairy-timeline',
  sectionUpairyCard: 'section-upairy-card',
  sectionUpairyCompareCard: 'section-upairy-compare-card',
  sectionKonfortifyFb: 'section-konfortify-fb',
  sectionKonfortifyCardBasic: 'section-konfortify-card-basic',
  sectionKonfortifyBanner: 'section-konfortify-banner',
  sectionKonfortifyReviewGrid: 'section-konfortify-review-grid',
  sectionFurnitureshopBanner: 'section-furnitureshop-banner',
  sectionFurnitureshopCardStep: 'section-furnitureshop-card-step',
  sectionFurnitureshopGridSlider: 'section-furnitureshop-grid-slider',
  sectionFurnitureshopGridSlider02: 'section-furnitureshop-grid-slider-02',
  sectionFurnitureshopSpecification: 'section-furnitureshop-specification',
  sectionFurnitureshopCarousel: 'section-furnitureshop-carousel',
  sectionFurnitureshopReward: 'section-furnitureshop-reward',
  sectionFurnitureshopBanner02: 'section-furnitureshop-banner-02',
  sectionFurnitureshopBanner03: 'section-furnitureshop-banner-03',
  sectionFurnitureshopFaq: 'section-furnitureshop-faq',
  sectionFeetscareListImage: 'section-feetscare-list-image',
  sectionFeetscareListItem: 'section-feetscare-list-item',
  sectionFeetscareStat: 'section-feetscare-stat',
  sectionFeetscareSatellite: 'section-feetscare-satellite',
  sectionManchestoreCompareSlider: 'section-manchestore-compare-slider',
  sectionManchestoreBanner: 'section-manchestore-banner',
  sectionSofyreTabsReview: 'section-sofyre-tabs-review',
  sectionSofyreTimeline: 'section-sofyre-timeline',
  sectionSofyreIngredients: 'section-sofyre-ingredients',
  sectionSofyreUserManual: 'section-sofyre-user-manual',
  sectionSofyreComparison: 'section-sofyre-comparison',

  //harrybox
  sectionMadamSizeCalculator: 'section-madam-size-calculator',
  sectionEskiinHurrybox: 'section-eskiin-hurrybox',

  //order policy
  sectionEskiinPolicy: 'section-eskiin-policy',
};
